import React, { useState } from 'react';
import './App.css';
import Login from './components/Login';
import TranscriptViewer from './components/TranscriptViewer';
import { apiService } from './apiService';

interface User {
  email: string;
  token: string;
}

function App() {
  const [user, setUser] = useState<User | null>(null);

  const handleLogin = (token: string, email: string) => {
    const userData = { email, token };
    setUser(userData);
    apiService.setToken(token);
  };

  const handleLogout = () => {
    window.localStorage.removeItem('lastToken');
    setUser(null);
    apiService.setToken('');
  };

  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <TranscriptViewer 
      userEmail={user.email} 
      onLogout={handleLogout} 
    />
  );
}

export default App;
